import React from 'react';
import { Link } from 'react-router-dom';

const Career = () => {
    return (
        <section id="career" className="career">
            <h2>Currently, I work</h2>
            <div>
                <p>@ the <Link  to="https://www.intel.com/" className="custom-link">
                        Intel Corporation
                    </Link> as a Machine Learning Engineer</p>
                <p>@ <Link  to="https://www.tbench.ai/" className="custom-link">
                    Terminal Bench
                </Link> making benchmarks for Agents</p>
            </div>
        </section>
    );
};

export default Career;
